module.exports = __webpack_public_path__ + "img/page-ico.d06db5d8.png";